import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config } from '../../../shared';
import { EmailThreadContainer } from '../../../../../../../models/mongodbSchema/aggregates';

@Injectable({ providedIn: 'root' })
export class EmailThreadService extends BaseApiTemplateService<EmailThreadContainer> {

  constructor(private http: HttpClient) {
    super();
    this.apiUrl =  Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "email-thread"
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "email-thread"
    this.httpClient = http
  }

  public closeActiveTask(emailThreadUuid: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + `/${emailThreadUuid}/task/close`;
    return this.httpClient.put<BasicApiResponseModel<EmailThreadContainer>>(
      url,
      {},
      this.getHttpHeader(apiVisa)
    );
  }
  public reportSpam(email_thread_id: string, is_spam: boolean, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/' + email_thread_id + '/update/spam'
    return this.httpClient.put(
      url,
      { is_spam: is_spam },
      this.getHttpHeader(apiVisa)
    )
  }
}